import { decodeJwt } from 'jose'
import jsCookies from 'js-cookie'

export function getJWTExpiryFromCookieClient(cookieName: string) {
  let tokenExpirationDateInSeconds = 0

  const cookieValue = jsCookies.get(cookieName)

  if (cookieValue) {
    try {
      const decodedToken = decodeJwt(cookieValue)

      if (decodedToken.exp) {
        tokenExpirationDateInSeconds = decodedToken.exp
      }
    } catch {
      // Do nothing, token expiration is already set to 0,
    }
  }

  return tokenExpirationDateInSeconds
}
